import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ImageAspectRatioService {

  constructor() { /* */ }

  async getImageAspectRatio(imageSrc: string): Promise<number> {
    return new Promise<number>((resolve, reject) => {
      const img = new Image();
      img.onload = function() {
        const aspectRatio = (this as HTMLImageElement).width / (this as HTMLImageElement).height;
        resolve(aspectRatio);
      };
      img.onerror = function() {
        reject("Failed to load image");
      };
      img.src = imageSrc;
    });
  }
}
